module.exports = __webpack_public_path__ + "static/media/LeaveFwd.16aa4b3b.svg";